import { render, staticRenderFns } from "./MobileRecordItem.vue?vue&type=template&id=3d0b57fa&scoped=true&"
import script from "./MobileRecordItem.vue?vue&type=script&lang=js&"
export * from "./MobileRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./MobileRecordItem.vue?vue&type=style&index=0&id=3d0b57fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b57fa",
  null
  
)

export default component.exports